export const CARDS_PAGE_MAP: Record<string, any> = {
  1: {
    title: 'Мои первые деньги',
    description: 'Объясним, что такое деньги и&nbsp;зачем они нужны',
    descriptionList: [
      '&bull; узнаем, как появились первые деньги и&nbsp;как они изменились со&nbsp;временем',
      '&bull; разберемся, как обращаться с&nbsp;деньгами и&nbsp;зачем нужны банки и&nbsp;карты',
      '&bull; научимся пользоваться онлайн-банком',
    ],
    cards: [
      {
        title: '1. От&nbsp;обмена&nbsp;&mdash; к&nbsp;деньгам',
        list: [
          '&bull; узнаем, как люди обходились без денег и&nbsp;зачем их&nbsp;придумали',
          '&bull; поиграем в&nbsp;рынок &laquo;обмена&raquo;',
        ],
        date: '15 декабря 19:00',
      },
      {
        title: '2. Как устроены деньги?',
        list: [
          '&bull; изучим внешний вид банкнот и&nbsp;монет',
          '&bull; узнаем, для чего изображают на&nbsp;деньгах символы государства',
        ],
        date: '24 декабря 19:00',
      },
      {
        title: '3. Какие деньги настоящие?',
        list: [
          '&bull; узнаем, что защищает деньги',
          '&bull; научимся отличать настоящие деньги от&nbsp;подделок',
        ],
        date: '15 января 19:00',
      },
      {
        title: '4. Разнообразие денег',
        list: [
          '&bull; узнаем, какие бывают деньги&nbsp;&mdash; монеты, купюры и&nbsp;цифровые',
          '&bull; посмотрим, какие валюты есть в&nbsp;разных странах',
        ],
        date: '20 января 19:00',
      },
      {
        title: '5. Современные деньги',
        list: [
          '&bull; узнаем о&nbsp;безналичной оплате',
          '&bull; обсудим, как безопасно оплачивать товары картой',
        ],
        date: '27 января 19:00',
      },
    ],
  },
  2: {
    title: 'Я осваиваю компьютер',
    description: 'Научим пользоваться компьютером уверенно и&nbsp;безопасно',
    descriptionList: [
      '&bull; познакомимся с&nbsp;компонентами компьютера и&nbsp;их назначением',
      '&bull; научимся вводить текст, работать с файлами и&nbsp;папками',
      '&bull; освоим контекстное меню и&nbsp;правила безопасного обращения с&nbsp;техникой',
    ],
    cards: [
      {
        title: '1. Компоненты компьютера',
        list: [
          '&bull; изучим строение компьютера',
          '&bull; научимся различать устройства ввода и&nbsp;вывода информации',
        ],
        date: '22 декабря 19:00',
      },
      {
        title: '2. Клавиатура и&nbsp;мышь',
        list: [
          '&bull; узнаем о&nbsp;функциях мыши',
          '&bull; научимся вводить текст и&nbsp;исправлять ошибки',
        ],
        date: '19 января 19:00',
      },
      {
        title: '3. Файлы и&nbsp;папки',
        list: [
          '&bull; научимся работать с&nbsp;файлами',
          '&bull; узнаем, как папки помогают упорядочить файлы',
        ],
        date: '23 января 19:00',
      },
      {
        title: '4. Файлы и&nbsp;программы',
        list: [
          '&bull; научимся работать с&nbsp;файлами в&nbsp;разных программах',
          '&bull; узнаем, как сохранять данные',
        ],
        date: '30 января 19:00',
      },
      {
        title: '5. Как защитить компьютер',
        list: [
          '&bull; узнаем, как безопасно пользоваться компьютером',
          '&bull; научимся способам его защиты',
        ],
        date: '3 февраля 19:00',
      },
    ],
  },
  3: {
    title: 'Моя книжная  полка',
    description: 'Научим понимать и&nbsp;обсуждать современные книги',
    descriptionList: [
      '&bull; проанализируем содержание произведений',
      '&bull; научимся выделять тему и главную мысль',
      '&bull; будем описывать героев и&nbsp;высказывать мнение о&nbsp;произведениях',
    ],
    cards: [
      {
        title: '1. Автор книг и&nbsp;его герои',
        list: [
          '&bull; научимся различать автора и&nbsp;героя книги',
          '&bull; разберем фрагменты книги',
        ],
        date: '16 января 19:00',
      },
      {
        title: '2. Герой произведения',
        list: [
          '&bull; оценим поступки героев',
          '&bull; опишем характеры героев через их&nbsp;слова и&nbsp;действия',
        ],
        date: '22 января 19:00',
      },
      {
        title: '3. Настроение книги',
        list: [
          '&bull; узнаем, как его определить по&nbsp;выразительным средствам',
          '&bull; разберем фрагменты книги',
        ],
        date: '28 января 19:00',
      },
      {
        title: '4. Современная сказка',
        list: ['&bull; определим признаки сказки', '&bull; сочиним собственную сказку'],
        date: '5 февраля 19:00',
      },
      {
        title: '5. Как рассказать о&nbsp;книге?',
        list: [
          '&bull; составим план отзыва о&nbsp;книге',
          '&bull; напишем свой отзыв о&nbsp;понравившейся книге',
        ],
        date: '12 февраля 19:00',
      },
    ],
  },
  4: {
    title: 'Безопасность в жизни и сети',
    description:
      'Научим быть внимательными и&nbsp;осторожными дома, на&nbsp;улице и&nbsp;в&nbsp;сети',
    descriptionList: [
      '&bull; узнаем, какие опасные ситуации бывают и&nbsp;как их&nbsp;не&nbsp;допускать',
      '&bull; потренируемся действовать правильно в&nbsp;игровых ситуациях',
      '&bull; обсудим правила поведения и&nbsp;способы получения помощи',
    ],
    cards: [
      {
        title: '1. Безопасность дома',
        list: [
          '&bull; узнаем, что дома безопасно, а&nbsp;что&nbsp;&mdash; нет',
          '&bull; научим осторожности дома',
        ],
        date: '30 января 19:00',
      },
      {
        title: '2. Безопасность на&nbsp;дороге',
        list: [
          '&bull; вспомним дорожные сигналы',
          '&bull; закрепим правила безопасного поведения на&nbsp;дороге',
        ],
        date: '4 февраля 19:00',
      },
      {
        title: '3. Безопасная прогулка',
        list: [
          '&bull; узнаем, как вести себя на&nbsp;улице',
          '&bull; научим безопасно общаться с&nbsp;животными',
        ],
        date: '11 февраля 19:00',
      },
      {
        title: '4. Я&nbsp;и&nbsp;незнакомцы',
        list: [
          '&bull; научимся правильно реагировать на&nbsp;незнакомцев',
          '&bull; узнаем, как себя защитить',
        ],
        date: '18 февраля 19:00',
      },
      {
        title: '5. Безопасный интернет',
        list: ['&bull; узнаем о&nbsp;правилах онлайн-общения', '&bull; научимся создавать пароли'],
        date: '25 февраля 19:00',
      },
    ],
  },
  5: {
    title: 'Как дружить?',
    description: 'Научим строить дружеские отношения и&nbsp;разрешать споры',
    descriptionList: [
      '&bull; научимся выражать эмоции словесно и&nbsp;слушать собеседника',
      '&bull; разберемся, как мириться, просить прощения и&nbsp;поддерживать друзей',
      '&bull; узнаем, как реагировать на&nbsp;обиды и&nbsp;в&nbsp;каких случаях обращаться за&nbsp;помощью к&nbsp;взрослым',
    ],
    cards: [
      {
        title: '1. Что значит быть другом?',
        list: [
          '&bull; определим, какими качествами должен обладать друг',
          '&bull; пробуем быть хорошим другом',
        ],
        date: '3 февраля 19:00',
      },
      {
        title: '2. Важно ли благодарить?',
        list: [
          '&bull; узнаем, зачем говорить &laquo;спасибо&raquo; и&nbsp;почему это важно',
          '&bull; пробуем укреплять дружбу',
        ],
        date: '12 февраля 19:00',
      },
      {
        title: '3. Слушаем и пониманием',
        list: [
          '&bull; учимся внимательно слушать собеседника',
          '&bull; учимся эмпатии в&nbsp;общении',
        ],
        date: '16 февраля 19:00',
      },
      {
        title: '4. Разрешаем конфликты',
        list: [
          '&bull; научимся отличать спор от&nbsp;конфликта',
          '&bull; пробуем мирно их&nbsp;разрешать',
        ],
        date: '27 февраля 19:00',
      },
      {
        title: '5. Работа в&nbsp;команде',
        list: [
          '&bull; учимся выполнять свою роль в&nbsp;командной работе',
          '&bull; практикуем инициативность',
        ],
        date: '3 марта 19:00',
      },
    ],
  },
  6: {
    title: 'Мыслим критически',
    description: 'Научим замечать, когда информации мало&nbsp;или она неверна',
    descriptionList: [
      '&bull; научимся задавать вопросы и&nbsp;проверять факты',
      '&bull; разберемся, как отличать правду от&nbsp;заблуждений на&nbsp;простых примерах',
      '&bull; узнаем, какие источники надежные и&nbsp;как ими пользоваться',
    ],
    cards: [
      {
        title: '1. Что знаем, а&nbsp;что&nbsp;&mdash; нет?',
        list: ['&bull; пробуем замечать неполную информацию', '&bull; учимся задавать вопросы'],
        date: '12 февраля 19:00',
      },
      {
        title: '2. Где искать правду?',
        list: ['&bull; узнаем о&nbsp;надeжных источниках', '&bull; учимся проверять информацию'],
        date: '18 февраля 19:00',
      },
      {
        title: '3. Где правда, а&nbsp;где&nbsp;&mdash; ложь?',
        list: ['&bull; учимся отличать факты от&nbsp;заблуждений', '&bull; анализируем информацию'],
        date: '26 февраля 19:00',
      },
      {
        title: '4. Читаем данные',
        list: [
          '&bull; научимся читать и&nbsp;понимать таблицы, схемы, графики и&nbsp;делать выводы',
        ],
        date: '5 марта 19:00',
      },
      {
        title: '5. Анализ информации',
        list: ['&bull; научимся разным приемам анализа информации и&nbsp;делать выводы'],
        date: '10 марта 19:00',
      },
    ],
  },
  7: {
    title: 'Финансы и я',
    description: 'Научим бережно относиться к&nbsp;семейному бюджету и&nbsp;планировать расходы',
    descriptionList: [
      '&bull; узнаем, откуда приходят и&nbsp;на&nbsp;что тратятся деньги',
      '&bull; научимся считать доходы, расходы и&nbsp;планировать бюджет',
      '&bull; сможем анализировать бюджет и&nbsp;предлагать, как его улучшить',
    ],
    cards: [
      {
        title: '1. Доходы и расходы',
        list: [
          '&bull; узнаем источники дохода семьи',
          '&bull; научимся распределять расходы по&nbsp;категориям',
        ],
        date: '15 декабря 19:00',
      },
      {
        title: '2. Формируем бюджет',
        list: ['&bull; научимся составлять и&nbsp;балансировать семейный бюджет'],
        date: '24 декабря 19:00',
      },
      {
        title: '3. Как копить?',
        list: [
          '&bull; поймем, зачем копить деньги',
          '&bull; посчитаем, сколько и&nbsp;как долго нужно копить на&nbsp;покупки',
        ],
        date: '15 января 19:00',
      },
      {
        title: '4. Современные деньги',
        list: [
          '&bull; разберемся, зачем нужны банки, схемы, графики и&nbsp;делать выводы',
          '&bull; узнаем о&nbsp;безналичных платежах',
        ],
        date: '20 января 19:00',
      },
      {
        title: '5. Планируем финансы',
        list: ['&bull; научимся планировать покупки и&nbsp;распределять бюджет на&nbsp;будущее'],
        date: '27 января 19:00',
      },
    ],
  },
  8: {
    title: 'Я осваиваю интернет',
    description: 'Научим безопасно и&nbsp;осознанно пользоваться интернетом',
    descriptionList: [
      '&bull; узнаем, как пользоваться браузером, искать информацию и&nbsp;общаться в&nbsp;сети',
      '&bull; научимся защищать свои персональные данные и&nbsp;создавать надежные пароли',
      '&bull; разберемся, как определять признаки мошенничества',
    ],
    cards: [
      {
        title: '1. Что такое браузер?',
        list: [
          '&bull; научимся использовать браузер',
          '&bull; узнаем, почему не&nbsp;все сайты безопасны',
        ],
        date: '22 декабря 19:00',
      },
      {
        title: '2. Как искать информацию?',
        list: ['&bull; научимся формулировать запросы и&nbsp;выбирать надежные источники'],
        date: '19 января 19:00',
      },
      {
        title: '3. Безопасный интернет',
        list: [
          '&bull; научимся защищать персональные данные надежными паролями и&nbsp;защищаться от&nbsp;мошенников',
        ],
        date: '23 января 19:00',
      },
      {
        title: '4. Общение в сети',
        list: [
          '&bull; научимся пользоваться почтой и&nbsp;мессенджерами',
          '&bull; узнаем сетевой этикет',
        ],
        date: '30 января 19:00',
      },
      {
        title: '5. Ответственность в&nbsp;сети',
        list: [
          '&bull; узнаем, что за&nbsp;действия в&nbsp;сети есть ответственность, и&nbsp;научимся уважительному общению',
        ],
        date: '3 февраля 19:00',
      },
    ],
  },
  9: {
    title: 'Моя книжная  полка',
    description: 'Научим понимать и&nbsp;обсуждать современные книги',
    descriptionList: [
      '&bull; проанализируем содержание произведений',
      '&bull; научимся выделять тему и <br/> главную мысль',
      '&bull; будем описывать героев и&nbsp;высказывать мнение о&nbsp;произведениях',
    ],
    cards: [
      {
        title: '1. Автор книг и&nbsp;его герои',
        list: [
          '&bull; научимся различать автора и&nbsp;героя книги',
          '&bull; разберем фрагменты книги',
        ],
        date: '16 января 19:00',
      },
      {
        title: '2. Герой произведения',
        list: [
          '&bull; оценим поступки героев',
          '&bull; опишем характеры героев через их&nbsp;слова и&nbsp;действия',
        ],
        date: '22 января 19:00',
      },
      {
        title: '3. Настроение книги',
        list: [
          '&bull; узнаем, как его определить по&nbsp;выразительным средствам',
          '&bull; разберем фрагменты книги',
        ],
        date: '28 января 19:00',
      },
      {
        title: '4. Современная сказка',
        list: ['&bull; определим признаки сказки', '&bull; сочиним собственную сказку'],
        date: '5 февраля 19:00',
      },
      {
        title: '5. Как рассказать о&nbsp;книге?',
        list: [
          '&bull; составим план отзыва о&nbsp;книге',
          '&bull; напишем свой отзыв о&nbsp;понравившейся книге',
        ],
        date: '12 февраля 19:00',
      },
    ],
  },
  10: {
    title: 'Текстовые задачи на движение',
    description: 'Научим понимать и&nbsp;решать задачи на&nbsp;движение',
    descriptionList: [
      '&bull; поймем связь между расстоянием, временем и&nbsp;скоростью',
      '&bull; научимся определять тип движения и&nbsp;выбирать способ решения задачи',
      '&bull; научимся переводить скорость между км/ч и&nbsp;м/с и&nbsp;находить среднюю скорость',
    ],
    cards: [
      {
        title: '1. Скорость, расстояние и время',
        list: ['&bull; узнаем связь между величинами', '&bull; научимся находить каждую величину'],
        date: '30 января 19:00',
      },
      {
        title: '2. Движение в&nbsp;одну сторону',
        list: ['&bull; научимся решать задачи, где один движется быстрее или начал раньше'],
        date: '4 февраля 19:00',
      },
      {
        title: '3. Движение навстречу',
        list: ['&bull; учимся рассчитывать время и&nbsp;находить место встречи'],
        date: '11 февраля 19:00',
      },
      {
        title: '4. Противоположное движение',
        list: ['&bull; научимся решать задачи, когда объекты движутся друг от&nbsp;друга'],
        date: '18 февраля 19:00',
      },
      {
        title: '5. Перевод величин и&nbsp;средняя скорость',
        list: [
          '&bull; узнаем, как находить среднюю скорость',
          '&bull; переведем км/ч в&nbsp;м/с и&nbsp;наоборот',
        ],
        date: '25 февраля 19:00',
      },
    ],
  },
  11: {
    title: 'Как дружить?',
    description: 'Научим решать конфликты и&nbsp;разовьем навыки общения',
    descriptionList: [
      '&bull; научимся строить дружеские отношения и&nbsp;проявлять уважение к&nbsp;другим',
      '&bull; научимся находить признаки травли и&nbsp;безопасно реагировать',
      '&bull; научимся выражать свои чувства и&nbsp;поддерживать друзей',
    ],
    cards: [
      {
        title: '1. Как мы общаемся?',
        list: [
          '&bull; узнаем, как слова, интонации и&nbsp;жесты влияют на&nbsp;отношения',
          '&bull; научимся бережному общению',
        ],
        date: '3 февраля 19:00',
      },
      {
        title: '2. Конфликт или травля?',
        list: [
          '&bull; узнаем, чем конфликт отличается от&nbsp;травли',
          '&bull; научимся реагировать на&nbsp;травлю',
        ],
        date: '12 февраля 19:00',
      },
      {
        title: '3. Личные границы',
        list: [
          '&bull; узнаем, что такое личное пространство',
          '&bull; научимся вежливо говорить о&nbsp;своих чувствах и&nbsp;границах',
        ],
        date: '16 февраля 19:00',
      },
      {
        title: '4. Если кто-то обижает',
        list: [
          '&bull; отличим шутки от&nbsp;травли',
          '&bull; научимся поддерживать пострадавшего и&nbsp;обращаться за&nbsp;помощью',
        ],
        date: '27 февраля 19:00',
      },
      {
        title: '5. Дружба и поддержка',
        list: [
          '&bull; узнаем, что делает коллектив дружным',
          '&bull; научимся помогать тем, кому трудно',
        ],
        date: '3 марта 19:00',
      },
    ],
  },
  12: {
    title: 'Мыслим критически',
    description: 'Научим замечать, когда информации мало&nbsp;или она неверна',
    descriptionList: [
      '&bull; научимся задавать вопросы и&nbsp;проверять факты',
      '&bull; разберемся, как отличать правду от&nbsp;заблуждений на&nbsp;простых примерах',
      '&bull; узнаем, какие источники надежные и&nbsp;как ими пользоваться',
    ],
    cards: [
      {
        title: '1. Что знаем, а&nbsp;что&nbsp;&mdash; нет?',
        list: ['&bull; пробуем замечать неполную информацию', '&bull; учимся задавать вопросы'],
        date: '12 февраля 19:00',
      },
      {
        title: '2. Где искать правду?',
        list: ['&bull; узнаем о&nbsp;надeжных источниках', '&bull; учимся проверять информацию'],
        date: '18 февраля 19:00',
      },
      {
        title: '3. Где правда, а&nbsp;где&nbsp;&mdash; ложь?',
        list: ['&bull; учимся отличать факты от&nbsp;заблуждений', '&bull; анализируем информацию'],
        date: '26 февраля 19:00',
      },
      {
        title: '4. Читаем данные',
        list: [
          '&bull; научимся читать и&nbsp;понимать таблицы, схемы, графики и&nbsp;делать выводы',
        ],
        date: '5 марта 19:00',
      },
      {
        title: '5. Анализ информации',
        list: ['&bull; научимся разным приемам анализа информации и&nbsp;делать выводы'],
        date: '10 марта 19:00',
      },
    ],
  },
};
